import { EnergyPassportDetailsTable } from "@/features/energy-passport/ui/detail-tables/energy-passport-details-table.tsx"
import { useEnergyPassportDetailsStore } from "@/features/energy-passport/ui/detail-tables/model/store.ts"

export function EnergyPassportThermalEnergyTable() {
  // Store
  const { heat } = useEnergyPassportDetailsStore()

  return <EnergyPassportDetailsTable title="Энергетический баланс тепловой энергии" storeItem={heat} />
}
